/** Paths that require an app interior grant (B1 / fail-closed routing). */
export const APP_INTERIOR_PATH_PREFIXES = [
  '/guided-studio',
  '/omnistudio',
  '/omnicine',
  '/omnicast',
  '/goalbuddy/app',
  '/goalbuddy/workspace',
  '/guided/start-from-world',
  '/xr',
  '/wearables/connect',
  '/onboarding/wearables',
] as const

export const CONTROLLED_ACCESS_HOLDING_PATH = '/access'

/** Dedicated pathway shell for requested_access / demo_booked (B3). */
export const PATHWAY_ACCESS_SHELL_PATH = '/access/pathway'

export const AUTH_LOGIN_PATH = '/login'

/** WordPress marketing site — public homepage (app `/` redirects to controlled access). */
export const MARKETING_HOMEPAGE_URL = 'https://synktribe.com' as const

const EXCLUDED_INTERIOR_PREFIXES = ['/command-deck/preview', '/command-deck'] as const

export function isAppInteriorPath(pathname: string): boolean {
  const path = pathname.split('?')[0] ?? pathname
  if (path === CONTROLLED_ACCESS_HOLDING_PATH || path.startsWith(`${CONTROLLED_ACCESS_HOLDING_PATH}/`)) {
    return false
  }
  if (path === AUTH_LOGIN_PATH || path.startsWith(`${AUTH_LOGIN_PATH}/`)) {
    return false
  }
  for (const excluded of EXCLUDED_INTERIOR_PREFIXES) {
    if (path === excluded || path.startsWith(`${excluded}/`)) {
      return false
    }
  }
  return APP_INTERIOR_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  )
}
